module.exports = __webpack_public_path__ + "static/pattern-f54ed8c132d452fb89669f60ed4af74c.png";